import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectListItems } from 'data/list/list-selectors';
import { makeSelectTopicData } from 'data/topic/topic-selectors';
import { makeSelectLang } from 'data/config/runtime-config-selectors';
import LandingPage from './landing-page';
import {
    makeSelectBasePath,
    makeSelectLandingPageDisplayAdConfig,
    makeSelectDefaultTopic,
} from 'data/config/runtime-config-selectors';
import { getLandingPageData } from 'data/landing-page/landing-page-actions';

const mapStateToProps = createStructuredSelector({
    list: makeSelectListItems(),
    topic: makeSelectTopicData(),
    defaultTopic: makeSelectDefaultTopic(),
    itemsBasePath: makeSelectBasePath(),
    displayAdConfig: makeSelectLandingPageDisplayAdConfig(),
    lang: makeSelectLang(),
});

const mapDispatchToProps = (dispatch) => ({
    getLandingPageData: id => dispatch(getLandingPageData(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
